import {
    BellIcon,
    CreditCardIcon,
    LogOutIcon,
    MoreVerticalIcon,
    UserCircleIcon,
    RepeatIcon,
    Globe,
    Check,
    SettingsIcon,
} from "lucide-react"
import {Link, useNavigate} from "react-router-dom"
import {useTranslation} from "react-i18next" // Add this import

import {
    Avatar,
    AvatarFallback,
    AvatarImage,
} from "@/components/ui/avatar"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuSub,
    DropdownMenuSubContent,
    DropdownMenuSubTrigger,
    DropdownMenuTrigger,
    DropdownMenuPortal,
} from "@/components/ui/dropdown-menu"
import {
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    useSidebar,
} from "@/components/ui/sidebar"
import axiosInstance from "@/api/axios";
import {useEffect, useState} from "react";

export function NavUser({
                            user,
                        }: {
    user: {
        name: string
        email: string
        avatar: string
    }
}) {
    const {isMobile} = useSidebar();
    const {t, i18n} = useTranslation(); // Add this line
    const [isAdmin, setIsAdmin] = useState(false);
    const [userCompany, setUserCompany] = useState(null);
    const CSU = "CSU";
    const PHASE5 = "phase5";
    const Demo = "Demo"
    const [userRole, setUserRole] = useState<string | null>(null);

    useEffect(() => {
        const fetchUserRole = async () => {
            try {
                const response = await axiosInstance.get("demo");
                console.log("Navbar:", response.data);
                setIsAdmin(response.data.can_access_demo);
                setUserRole(response.data.user_role);
                setUserCompany(response.data.user_company);
            } catch (error) {
                console.error("Error fetching user role:", error);
            }
        };

        fetchUserRole();
    }, []);

    const handleLanguageChange = (lang: string) => {
        // Use i18next to change language - this will trigger dynamic updates
        i18n.changeLanguage(lang);
        console.log(`Language changed to: ${lang}`);
    };

    const handleLogout = () => {
        try {
            axiosInstance.post("/user/logout", {
                withCredentials: true,
            });
            localStorage.removeItem("loggedin");
            window.location.href = "/login";
        } catch (e) {
            console.log("logout not working", e);
        } finally {
            localStorage.removeItem("loggedin");
            window.location.href = "/login";
        }
    };

    const avatarData = () => {
        let data = user.name;
        let firstCharacter = data.charAt(0)
        let secondCharacter = data.charAt(1)
        data = firstCharacter.concat(secondCharacter)
        return data.toString().toUpperCase();
    }

    return (
        <SidebarMenu>
            <SidebarMenuItem>
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <SidebarMenuButton
                            size="lg"
                            className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
                        >
                            <Avatar className="h-8 w-8 rounded-lg grayscale">
                                <AvatarImage src={user.avatar} alt={user.name}/>
                                <AvatarFallback className="rounded-lg">{avatarData()}</AvatarFallback>
                            </Avatar>
                            <div className="grid flex-1 text-left text-sm leading-tight">
                                <span className="truncate font-medium">{user.name}</span>
                                <span className="truncate text-xs text-muted-foreground">
                  {user.email}
                </span>
                            </div>
                            <MoreVerticalIcon className="ml-auto size-4"/>
                        </SidebarMenuButton>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent
                        className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
                        side={isMobile ? "bottom" : "right"}
                        align="end"
                        sideOffset={4}
                    >
                        <DropdownMenuLabel className="p-0 font-normal">
                            <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                                <Avatar className="h-8 w-8 rounded-lg">
                                    <AvatarImage src={user.avatar} alt={user.name}/>
                                    <AvatarFallback className="rounded-lg">CN</AvatarFallback>
                                </Avatar>
                                <div className="grid flex-1 text-left text-sm leading-tight">
                                    <span className="truncate font-medium">{user.name}</span>
                                    <span className="truncate text-xs text-muted-foreground">
                    {user.email}
                  </span>
                                </div>
                            </div>
                        </DropdownMenuLabel>
                        <DropdownMenuSeparator/>


                        <DropdownMenuGroup>
                            <DropdownMenuSub>
                                <DropdownMenuSubTrigger>
                                    <Globe className="mr-2 h-4 w-4"/>
                                    <span>{t("language")}</span>
                                </DropdownMenuSubTrigger>
                                <DropdownMenuPortal>
                                    <DropdownMenuSubContent>
                                        <DropdownMenuItem onClick={() => handleLanguageChange("en")}>
                                            {i18n.language === "en" && <Check className="mr-2 h-4 w-4"/>}
                                            {i18n.language !== "en" && <span className="mr-2 h-4 w-4"/>}
                                            <span>{t("english")}</span>
                                        </DropdownMenuItem>
                                        <DropdownMenuItem onClick={() => handleLanguageChange("nl")}>
                                            {i18n.language === "nl" && <Check className="mr-2 h-4 w-4"/>}
                                            {i18n.language !== "nl" && <span className="mr-2 h-4 w-4"/>}
                                            <span>{t("dutch")}</span>
                                        </DropdownMenuItem>
                                    </DropdownMenuSubContent>
                                </DropdownMenuPortal>
                            </DropdownMenuSub>

                            <DropdownMenuItem asChild>
                                <Link to="/account/security" className="flex items-center gap-2">
                                    <SettingsIcon className="mr-2 h-4 w-4"/>
                                    <span>{t("Settings")}</span>
                                </Link>
                            </DropdownMenuItem>
                        </DropdownMenuGroup>


                        <DropdownMenuSeparator/>
                        <DropdownMenuItem onClick={handleLogout} className="flex items-center gap-2">
                            <LogOutIcon className="h-4 w-4"/>
                            {t("logout")}
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </SidebarMenuItem>
        </SidebarMenu>
    )
}